module.exports = __webpack_public_path__ + "static/media/AP_ES_Z1.1aaa7fe6.png";